import AbstractViewManage from '@/class/view/AbstractViewManage'
import { getLoading } from '@/utils/utilBaseElement'
import { Once } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
const BACK_TO_FINANCE_MANAGE = 'backToFinanceManage'
import * as NumberUtils from '@/utils/NumberUtils'
export const events = { BACK_TO_FINANCE_MANAGE }
import StrUtils from '@/utils/StrUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'

export default class FinanceChargeSearch extends AbstractViewManage {
  /**
   * logger
   */
  // todo 日志

  constructor(view) {
    super(view)
    this.once = new Once(this)

    this.accountObj = ''
    this.currencyIndex = 0
    this.showPrintBtn = false
    this.useFinanceChargeExchangeRate = false
    this.checkJpyOpen = false
    this.exportEstimateTableConfig = false

    this.isHasRMB = true
    this.isHasUSD = true
    this.isHasEUR = true
    this.isHasHKD = true
    this.isHasJPY = true
    this.isHasGBP = true
    this.isHasNGN = true

    this.chargeList = []
    this.chargeGroupList = []
    this.chargeGroupListReceive = []
    this.chargeGroupListSend = []

    // this._selectChargeList = []
    // this._chargeListSend = []
    // this._chargeListReceive = []
    // this._isReceive = false
    this._selectChargeList = []
    this._chargeListSend = []
    this._chargeListReceive = []
    this._isReceive = false

    this._dataSource = []
    this.lastQueryOption = null
    this.category = 'CHARGE_LIST'
    this.configID = 'FinanceCharge' + this.$store.getters.userId.toString()
    this.config = null
  }

  //
  async init() {
    await cache.load(cacheName.CONFIG)
    this.config = cache.config

    this.useFinanceChargeExchangeRate = parseInt(this.config.get('useFinanceChargeExchangeRate')) === 1// 是否启用费用行上汇率
    this.checkJpyOpen = parseInt(this.config.get('checkJpyOpen')) === 1// 是否启用费用行上汇率
    // 是否启用导出预估表
    this.exportEstimateTableConfig = (parseInt(this.config.get('exportEstimateTableConfig')) === 1 && this.$checkPermission(['button_FinanceCharge_exportEstimateTable']))
  }
  transOtherCurrency(fields, _dataSource) {
    if (_dataSource) {
      const rateEUR = RateUtil.getForeignExchangeRateSafely('RMB', 'EUR', new Date(), 0, 6)
      const rateHKD = RateUtil.getForeignExchangeRateSafely('RMB', 'HKD', new Date(), 0, 6)
      const rateGBP = RateUtil.getForeignExchangeRateSafely('RMB', 'GBP', new Date(), 0, 6)
      const rateJPY = RateUtil.getForeignExchangeRateSafely('RMB', 'JPY', new Date(), 0, 6)
      const rateUSD = RateUtil.getForeignExchangeRateSafely('RMB', 'USD', new Date(), 0, 6)
      const rateNGN = RateUtil.getForeignExchangeRateSafely('RMB', 'NGN', new Date(), 0, 6)
      for (const d of _dataSource) {
        for (let i = 0; i < fields.length; i++) {
          if (rateEUR !== 0 && !isNaN(rateEUR)) { d[fields[i] + '_EUR'] = d[fields[i]] * rateEUR }
          if (rateHKD !== 0 && !isNaN(rateHKD)) { d[fields[i] + '_HKD'] = d[fields[i]] * rateHKD }
          if (rateGBP !== 0 && !isNaN(rateGBP)) { d[fields[i] + '_GBP'] = d[fields[i]] * rateGBP }
          if (rateJPY !== 0 && !isNaN(rateJPY)) { d[fields[i] + '_JPY'] = d[fields[i]] * rateJPY }
          if (rateNGN !== 0 && !isNaN(rateNGN)) { d[fields[i] + '_NGN'] = d[fields[i]] * rateJPY }
        }
        // 折合RMB应收
        let RMB_EQUIVALENT_RECEIVEABLE = 0.00
        // 折合RMB应付
        let RMB_EQUIVALENT_PAYABLE = 0.00
        // 折合RMB未收
        let RMB_NOT_RECEIVEABLE = 0.00
        // 折合RMB未付
        let RMB_NOT_PAYABLE = 0.00
        // [**useFinanceChargeExchangeRate是否启用当前参数启用则折合RMB应收/折合RMB应付/折合RMB未收/折合RMB未付对应汇率取当前费用详见对应sql代码**]
        if (this.useFinanceChargeExchangeRate) {
          RMB_EQUIVALENT_RECEIVEABLE = d['RECEIVE_EUR_AMOUNT'] + d['RECEIVE_GBP_AMOUNT'] + d['RECEIVE_HKD_AMOUNT'] + d['RECEIVE_JPY_AMOUNT'] + d['RECEIVE_USD_AMOUNT'] + d['RECEIVE_NGN_AMOUNT']
          RMB_EQUIVALENT_PAYABLE += d['PAY_EUR_AMOUNT'] + d['PAY_GBP_AMOUNT'] + d['PAY_HKD_AMOUNT'] + d['PAY_JPY_AMOUNT'] + d['PAY_USD_AMOUNT'] + d['PAY_NGN_AMOUNT']
          RMB_NOT_RECEIVEABLE += d['RECEIVE_UN_EUR_AMOUNT'] + d['RECEIVE_UN_GBP_AMOUNT'] + d['RECEIVE_UN_HKD_AMOUNT'] + d['RECEIVE_UN_HKD_AMOUNT'] + d['RECEIVE_UN_JPY_AMOUNT'] + d['RECEIVE_UN_USD_AMOUNT'] + d['RECEIVE_UN_NGN_AMOUNT']
          RMB_NOT_PAYABLE += d['PAY_UN_EUR_AMOUNT'] + d['PAY_UN_GBP_AMOUNT'] + d['PAY_UN_HKD_AMOUNT'] + d['PAY_UN_JPY_AMOUNT'] + d['PAY_UN_USD_AMOUNT'] + d['PAY_UN_NGN_AMOUNT']
        } else {
          if (!isNaN(rateEUR)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateEUR * d['RECEIVE_EUR']
            RMB_EQUIVALENT_PAYABLE += rateEUR * d['PAY_EUR']
            RMB_NOT_RECEIVEABLE += rateEUR * d['RECEIVE_UN_EUR']
            RMB_NOT_PAYABLE += rateEUR * d['PAY_UN_EUR']
          }
          if (!isNaN(rateGBP)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateGBP * d['RECEIVE_GBP']
            RMB_EQUIVALENT_PAYABLE += rateGBP * d['PAY_GBP']
            RMB_NOT_RECEIVEABLE += rateGBP * d['RECEIVE_UN_GBP']
            RMB_NOT_PAYABLE += rateGBP * d['PAY_UN_GBP']
          }
          if (!isNaN(rateHKD)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateHKD * d['RECEIVE_HKD']
            RMB_EQUIVALENT_PAYABLE += rateHKD * d['PAY_HKD']
            RMB_NOT_RECEIVEABLE += rateHKD * d['RECEIVE_UN_HKD']
            RMB_NOT_PAYABLE += rateHKD * d['PAY_UN_HKD']
          }
          if (!isNaN(rateJPY)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateJPY * d['RECEIVE_JPY']
            RMB_EQUIVALENT_PAYABLE += rateJPY * d['PAY_JPY']
            RMB_NOT_RECEIVEABLE += rateJPY * d['RECEIVE_UN_JPY']
            RMB_NOT_PAYABLE += rateJPY * d['PAY_UN_JPY']
          }
          if (!isNaN(rateUSD)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateUSD * d['RECEIVE_USD']
            RMB_EQUIVALENT_PAYABLE += rateUSD * d['PAY_USD']
            RMB_NOT_RECEIVEABLE += rateUSD * d['RECEIVE_UN_USD']
            RMB_NOT_PAYABLE += rateUSD * d['PAY_UN_USD']
          }

          if (!isNaN(rateNGN)) {
            RMB_EQUIVALENT_RECEIVEABLE += rateNGN * d['RECEIVE_NGN']
            RMB_EQUIVALENT_PAYABLE += rateNGN * d['PAY_NGN']
            RMB_NOT_RECEIVEABLE += rateNGN * d['RECEIVE_UN_NGN']
            RMB_NOT_PAYABLE += rateNGN * d['PAY_UN_NGN']
          }
        }

        d['rmbEquivalentReceiveable'] = NumberUtils.roundHalfUp2(RMB_EQUIVALENT_RECEIVEABLE + d['RECEIVE_RMB'], 2)
        d['RMB_EQUIVALENT_RECEIVEABLE'] = d['rmbEquivalentReceiveable'].toString()

        d['rmbEquivalentPayable'] = NumberUtils.roundHalfUp2(RMB_EQUIVALENT_PAYABLE + d['PAY_RMB'], 2)
        d['RMB_EQUIVALENT_PAYABLE'] = d['rmbEquivalentPayable'].toString()

        d['RMB_NOT_RECEIVEABLE'] = NumberUtils.roundHalfUp2(RMB_NOT_RECEIVEABLE + d['RECEIVE_UN_RMB'], 2).toString()

        d['RMB_NOT_PAYABLE'] = NumberUtils.roundHalfUp2(RMB_NOT_PAYABLE + d['PAY_UN_RMB'], 2).toString()
      }
    }
  }
  // 检索成功返回函数
  onSearch_Succeed(result) {
    // 每次查询都要重新初始化参数
    this.isHasRMB = true
    this.isHasUSD = true
    this.isHasEUR = true
    this.isHasHKD = true
    this.isHasJPY = true
    this.isHasGBP = true
    this.isHasNGN = true

    this._dataSource = result
    const _dataSource = this._dataSource
    const fields = ['RECEIVE_OTHER', 'PAY_OTHER', 'RECEIVE_UN_OTHER', 'PAY_UN_OTHER']
    this.transOtherCurrency(fields, _dataSource)

    if (this._dataSource && _dataSource.length > 0) {
      for (const source of _dataSource) {
        if (source['RECEIVE_RMB'] !== 0 || source['PAY_RMB'] !== 0 || source['RECEIVE_UN_RMB'] !== 0 || source['PAY_UN_RMB'] !== 0 || source['RECEIVED_RMB'] !== 0 || source['PAY_PAID_RMB'] !== 0) {
          if (this.isHasRMB) {
            this.isHasRMB = false
          }
        }
        if (source['RECEIVE_EUR'] !== 0 || source['PAY_EUR'] !== 0 || source['RECEIVE_UN_EUR'] !== 0 || source['PAY_UN_EUR'] !== 0 || source['RECEIVED_EUR'] !== 0 || source['PAY_PAID_EUR'] !== 0) {
          if (this.isHasEUR) {
            this.isHasEUR = false
          }
        }
        if (source['RECEIVE_USD'] !== 0 || source['PAY_USD'] !== 0 || source['RECEIVE_UN_USD'] !== 0 || source['PAY_UN_USD'] !== 0 || source['RECEIVED_USD'] !== 0 || source['PAY_PAID_USD'] !== 0) {
          if (this.isHasUSD) {
            this.isHasUSD = false
          }
        }
        if (source['RECEIVE_HKD'] !== 0 || source['PAY_HKD'] !== 0 || source['RECEIVE_UN_HKD'] !== 0 || source['PAY_UN_HKD'] !== 0 || source['RECEIVED_HKD'] !== 0 || source['PAY_PAID_HKD'] !== 0) {
          if (this.isHasHKD) {
            this.isHasHKD = false
          }
        }
        if (source['RECEIVE_JPY'] !== 0 || source['PAY_JPY'] !== 0 || source['RECEIVE_UN_JPY'] !== 0 || source['PAY_UN_JPY'] !== 0 || source['RECEIVED_JPY'] !== 0 || source['PAY_PAID_JPY'] !== 0) {
          if (this.isHasJPY) {
            this.isHasJPY = false
          }
        }
        if (source['RECEIVE_GBP'] !== 0 || source['PAY_GBP'] !== 0 || source['RECEIVE_UN_GBP'] !== 0 || source['PAY_UN_GBP'] !== 0 || source['RECEIVED_GBP'] !== 0 || source['PAY_PAID_GBP'] !== 0) {
          if (this.isHasGBP) {
            this.isHasGBP = false
          }
        }
        if (source['RECEIVE_NGN'] !== 0 || source['PAY_NGN'] !== 0 || source['RECEIVE_UN_NGN'] !== 0 || source['PAY_UN_NGN'] !== 0 || source['RECEIVED_NGN'] !== 0 || source['PAY_PAID_NGN'] !== 0) {
          if (this.isHasNGN) {
            this.isHasNGN = false
          }
        }
      }
    }
    if (!_dataSource || _dataSource.length === 0) {
      this.$message.info(this.$t('CargoMsg.Cargo_NoEligibleRecord'))
    }
    switch (this._view.tabs.currentTabName) {
      case 'job': {
        this.changeColumnVisible(this._view.$refs['tab' + this._view.tabs.job.name].gridOptions)
        this.equivalentRmb(_dataSource)
        this._view.tabs.job.dataProvider = _dataSource
        // this.setJobSource(_dataSource); // 共用dataSource,无需设置
        break
      }
      case 'charge': {
        for (const item of _dataSource) {
          if (item.ACCOUNT_RECEIVABLE) {
            item.rmbEquivalentReceiveable = item.CONVERT_TO_RMB
            item.rmbEquivalentPayable = 0
            item.EQUIVALENT_RMB = item.CONVERT_TO_RMB
          } else {
            item.rmbEquivalentReceiveable = 0
            item.rmbEquivalentPayable = item.CONVERT_TO_RMB
            item.EQUIVALENT_RMB = item.CONVERT_TO_RMB * -1
          }
        }
        this._view.tabs.charge.dataProvider = _dataSource
        // this.setChargeSource(_dataSource);// 共用dataSource,无需设置
        break
      }
      case 'invoice': {
        this.calculateCnyAmountOfInvoice(_dataSource)
        this._view.tabs.invoice.dataProvider = _dataSource
        // this.setInvoiceSource(_dataSource);// 共用dataSource,无需设置
        break
      }
      case 'bill': {
        this.calculateCnyAmountOfBill(_dataSource)
        this._view.tabs.bill.dataProvider = _dataSource
        break
      }
      case 'account': {
        this.changeColumnVisible(this._view.$refs['tab' + this._view.tabs.job.name].gridOptions)
        this.convertToCny(_dataSource)
        for (const item of _dataSource) {
          item.EQUIVALENT_RMB = item.OTHER_RECEIVE_AMOUNT - item.OTHER_PAY_AMOUNT
        }
        this._view.tabs.account.dataProvider = _dataSource
        // this.setAccountSource(_dataSource);// 共用dataSource,无需设置
        break
      }
      default:
        break
    }
  }
  // 计算折合CNY金额
  calculateCnyAmountOfInvoice(dataSource) {
    if (!dataSource || dataSource.length <= 0) return
    for (const item of dataSource) {
      let rate = 1
      if (item.currency !== item.CURRENCY_ORI) {
        rate = RateUtil.getForeignExchangeRateSafely('RMB', item.currency, new Date(), 0, 6)
      }
      if (item['AR']) {
        item['CONVERT_TO_CNY_AR'] = (item['VERIFIED_AMOUNT'] + item['AMOUNT_UN']) * rate
      } else {
        item['CONVERT_TO_CNY_AP'] = (item['VERIFIED_AMOUNT'] + item['AMOUNT_UN']) * rate
      }
      item['CONVERT_TO_CNY_PROFIT'] = item['CONVERT_TO_CNY_AR'] - item['CONVERT_TO_CNY_AP']
    }
  }
  // 计算折合CNY金额
  calculateCnyAmountOfBill(dataSource) {
    if (!dataSource || dataSource.length <= 0) return
    for (const item of dataSource) {
      const rate = RateUtil.getForeignExchangeRateSafely('RMB', item.currency, new Date(), 0, 6)
      item['CONVERT_TO_CNY_AR'] = 0
      item['CONVERT_TO_CNY_AP'] = 0
      if (!isNaN(rate)) {
        if (item['AR']) {
          item['CONVERT_TO_CNY_AR'] = rate * item['AMOUNT']
        } else {
          item['CONVERT_TO_CNY_AP'] = rate * item['AMOUNT']
        }
      }
      item['CONVERT_TO_CNY_PROFIT'] = item['CONVERT_TO_CNY_AR'] - item['CONVERT_TO_CNY_AP']
    }
  }
  // 将后端传递过来的未核销分币种合计字符串转换为数组
  getUnverifiedAmountDetail(dataList, currencyField, amountField, arField = null) {
    const countSource = []
    for (const obj of dataList) {
      const unVerifiedChargeDetailStr = String(obj['UN_VERIFIED_AMOUNT_DETAIL'])
      if (!StrUtils.isEmpty(unVerifiedChargeDetailStr)) {
        const unVerifiedChargeDetailArray = unVerifiedChargeDetailStr.split(';')
        for (const am of unVerifiedChargeDetailArray) {
          const unVerifiedAmountChargeDetailArray = am.split(':')
          if (unVerifiedAmountChargeDetailArray.length > 1) {
            const amountObj = {}
            amountObj['UUID'] = obj.UUID
            amountObj[currencyField] = unVerifiedAmountChargeDetailArray[0]
            amountObj[amountField] = Number(unVerifiedAmountChargeDetailArray[1])
            amountObj['isSelect'] = obj.isSelect
            if (arField != null) {
              amountObj[arField] = obj[arField]
            }
            countSource.push(amountObj)
          }
        }
      }
    }
    return countSource
  }
  //
  equivalentRmb(dataSource) {
    if (!dataSource || dataSource.length <= 0) return
    for (const item of dataSource) {
      const arAmount = item['RECEIVE_EQUIVALENT_RMB']
      const apAmount = item['PAY_EQUIVALENT_RMB']
      const amount = arAmount - apAmount
      item['EQUIVALENT_RMB'] = isNaN(amount) ? 0 : amount
    }
  }
  // CARGO-19324 年前：财务综合查询-结算对象模块显示列、下方合计添加 ‘应收折算合计’和‘应付折算合计’
  convertToCny(dataSource) {
    if (!dataSource || dataSource.length <= 0) return
    for (const item of dataSource) {
      const receiveOther = item['RECEIVE_OTHER']
      const receiveRmb = item['RECEIVE_RMB']
      const amountAr = receiveOther + receiveRmb
      item['CONVERT_TO_CNY_AR'] = isNaN(amountAr) ? 0 : amountAr

      const payOther = item['PAY_OTHER']
      const payRmb = item['PAY_RMB']
      const amountAp = payOther + payRmb
      item['CONVERT_TO_CNY_AP'] = isNaN(amountAp) ? 0 : amountAp
    }
  }
  exportToExcel(rows, tabRefObj, fileName) {
    const fields = ['RECEIVE_OTHER', 'PAY_OTHER', 'RECEIVE_UN_OTHER', 'PAY_UN_OTHER']
    this.transOtherCurrency(fields, rows)
    if (this._view.tabs.currentTabName === 'job') {
      this.equivalentRmb(rows)
    }
    // 获取显示列
    const allDisplayedColumns = tabRefObj.gridOptions.columnApi.getAllDisplayedColumns()
    // 获取选中行
    if (rows.length === 0) {
      this.$alert(this.$t('CargoMsg.Cargo_NoData'), this.$t('CargoMsg.Cargo_Prompt'), {
        confirmButtonText: this.$t('Clearing.Confirm'),
        type: 'warning'
      })
      return
    }
    this.loading = getLoading()
    setTimeout(() => {
      exportExcel(fileName, rows, allDisplayedColumns)
      this.loading.close()
    }, 100)
  }
  // // todo-shengsheng  Desc: 重置 表格数据
  onReset() {
    switch (this._view.tabs.currentTabName) {
      case 'job': {
        this._view.tabs.job.dataProvider = []
        break
      }
      case 'charge': {
        this._view.tabs.charge.dataProvider = []
        break
      }
      case 'invoice': {
        this._view.tabs.invoice.dataProvider = []
        break
      }
      case 'bill': {
        this._view.tabs.bill.dataProvider = []
        break
      }
      case 'account': {
        this._view.tabs.account.dataProvider = []
        break
      }
      default:
        break
    }
  }
  //
  changeColumnVisible(gridOptions) {
    const { columnApi, columnDefs } = gridOptions
    const accountDynamicColumn = this._view.tabs.account.dynamicColumn && this._view.tabs.account.name === this._view.tabs.currentTabName
    const jobDynamicColumn = this._view.tabs.job.dynamicColumn && this._view.tabs.job.name === this._view.tabs.currentTabName
    if (!accountDynamicColumn && !jobDynamicColumn) {
      // todo没有勾选的情况，需要 显示自定义的配置
      if (this._view.tabs[this._view.tabs.currentTabName].lastColumnConfigBeforeDynamic) {
        // 说明勾选后列状态没发生变化，则恢复到勾选前的状态
        columnApi.setColumnState(JSON.parse(this._view.tabs[this._view.tabs.currentTabName].lastColumnConfigBeforeDynamic))
      }
      this._view.tabs[this._view.tabs.currentTabName].lastColumnConfigBeforeDynamic = ''
    } else {
      // CARGO-7754 以自定义勾选的显示优先
      // 保存勾选前的状态，为了恢复自定义配置
      this._view.tabs[this._view.tabs.currentTabName].lastColumnConfigBeforeDynamic = JSON.stringify(columnApi.getColumnState())
      for (let i = 0; i < columnDefs.length; i++) {
        const column = columnDefs[i]
        if (column.field === 'RECEIVE_USD' || column.field === 'PAY_USD' || column.field === 'RECEIVE_UN_USD' || column.field === 'PAY_UN_USD') {
          column.visible = !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_RMB' || column.field === 'PAY_RMB' || column.field === 'RECEIVE_UN_RMB' || column.field === 'PAY_UN_RMB') {
          column.visible = !this.isHasRMB
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_EUR' || column.field === 'PAY_EUR' || column.field === 'RECEIVE_UN_EUR' || column.field === 'PAY_UN_EUR') {
          column.visible = !this.isHasEUR
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_HKD' || column.field === 'PAY_HKD' || column.field === 'RECEIVE_UN_HKD' || column.field === 'PAY_UN_HKD') {
          column.visible = !this.isHasHKD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_NGN' || column.field === 'PAY_NGN' || column.field === 'RECEIVE_UN_NGN' || column.field === 'PAY_UN_NGN') {
          column.visible = !this.isHasNGN
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_JPY' || column.field === 'PAY_JPY' || column.field === 'RECEIVE_UN_JPY' || column.field === 'PAY_UN_JPY') {
          column.visible = !this.isHasJPY
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_GBP' || column.field === 'PAY_GBP' || column.field === 'RECEIVE_UN_GBP' || column.field === 'PAY_UN_GBP') {
          column.visible = !this.isHasGBP
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER' || column.field === 'PAY_OTHER' || column.field === 'PAY_UN_OTHER' || column.field === 'PAY_UN_OTHER') {
          column.visible = !this.isHasEUR || !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasNGN || !this.isHasUSD

          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER' || column.field === 'PAY_OTHER' || column.field === 'PAY_UN_OTHER' || column.field === 'PAY_UN_OTHER') {
          column.visible = !this.isHasEUR || !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasNGN || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER' || column.field === 'PAY_OTHER' || column.field === 'PAY_UN_OTHER' || column.field === 'PAY_UN_OTHER') {
          column.visible = !this.isHasEUR || !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasNGN || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER_EUR' || column.field === 'PAY_OTHER_EUR' || column.field === 'RECEIVE_UN_OTHER_EUR' || column.field === 'PAY_UN_OTHER_EUR') {
          column.visible = !this.isHasRMB || !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasNGN || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER_HKD' || column.field === 'PAY_OTHER_HKD' || column.field === 'RECEIVE_UN_OTHER_HKD' || column.field === 'PAY_UN_OTHER_HKD') {
          column.visible = !this.isHasRMB || !this.isHasGBP || !this.isHasEUR || !this.isHasJPY || !this.isHasNGN || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER_NGN' || column.field === 'PAY_OTHER_NGN' || column.field === 'RECEIVE_UN_OTHER_NGN' || column.field === 'PAY_UN_OTHER_NGN') {
          column.visible = !this.isHasEUR || !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasRMB || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }
        if (column.field === 'RECEIVE_OTHER_JPY' || column.field === 'PAY_OTHER_JPY' || column.field === 'RECEIVE_UN_OTHER_JPY' || column.field === 'PAY_UN_OTHER_JPY') {
          column.visible = !this.isHasEUR || !this.isHasGBP || !this.isHasHKD || !this.isHasRMB || !this.isHasRMB || !this.isHasUSD
          columnApi.setColumnVisible(column.colId, column.visible)
        }

        if (this._view.tabs.job.name === this._view.tabs.currentTabName) {
          // 业务编号
          if (column.field === 'receiveOther' || column.field === 'payOther' || column.field === 'receiveUnOther' || column.field === 'payUnOther') {
            column.visible = !this.isHasGBP || !this.isHasHKD || !this.isHasJPY || !this.isHasRMB || !this.isHasNGN || !this.isHasUSD
            columnApi.setColumnVisible(column.colId, column.visible)
          }
        }
      }
    }
  }
}
